import { services } from "@/mocks/home";

export default function Services() {
  return (
    <section id="services" className="bg-background-100 py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="text-primary-600 text-xs tracking-[0.32em] font-semibold mb-4">
              WHAT WE DO
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
              여섯 가지 <span className="text-primary-600">전문 분야</span>
            </h2>
          </div>
          <p className="max-w-md text-foreground-700 text-sm md:text-base leading-relaxed">
            개인보험부터 근재보험, 교통사고, 손해배상, 화재, 누수까지
            다양한 분야에서 전문적인 손해사정 서비스를 제공합니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <a
              href="#inquiry"
              key={s.ttl}
              className="group bg-background-50 border border-primary-400 rounded-lg p-8 transition-all duration-300 relative overflow-hidden block"
            >
              <div className="absolute -right-6 -top-6 w-24 h-24 rounded-full bg-primary-100"></div>
              <div className="relative">
                <div className="flex items-start justify-between mb-6">
                  <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 transition">
                    <i className={`${s.icon} text-2xl`}></i>
                  </span>
                  <span className="text-primary-200 font-heading text-3xl font-bold">
                    0{i + 1}
                  </span>
                </div>
                <div className="text-xs text-primary-600 tracking-[0.24em] font-semibold">
                  {s.en.toUpperCase()}
                </div>
                <div className="font-heading font-bold text-2xl text-foreground-950 mt-1">
                  {s.ttl}
                </div>
                <p className="mt-4 text-sm text-foreground-700 leading-relaxed min-h-[72px]">
                  {s.desc}
                </p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span
                      key={t}
                      className="px-3 py-1 rounded-full bg-secondary-200 text-secondary-900 text-xs font-medium"
                    >
                      #{t}
                    </span>
                  ))}
                </div>
                <a
                  href="tel:010-2696-9689"
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 transition cursor-pointer whitespace-nowrap"
                >
                  상담문의
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}